import axios from "axios";

const API_URL = process.env.VUE_APP_BASE_URL;

const instance = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Credentials": true,
    "Access-Control-Allow-Headers":
      "Origin, X-Requested-With, Content-Type, Accept",
  },
});

// Attach isCancel() to the custom instance
instance.isCancel = axios.isCancel;

export default instance;
